import useMeetingsRefresh from "../../hooks/useMeetingsRefresh";
import RefreshMeetingsButton from "./RefreshMeetingsButton";
import React, { useEffect, useRef, useState } from "react";
import { useContext } from "react";
import TherapyRoomCard from "./TherapyRoomCard";
import Navbar from "../Navbar";
import FallScene from "../FallScene";
import Footer from "../Footer";
import TherapistSidebar from "../TherapistSidebar";
import TherapistClients from "../TherapistClients";
import ClientChatHistory from "../ClientChatHistory";
import beach from "../../assets/images/beach.png";
import forest from "../../assets/images/forest.png";
import campsite from "../../assets/images/campsite.png";
import winterHoliday from "../../assets/images/winterHoliday.png"
import zen from "../../assets/images/zen.png"
import park from "../../assets/images/park.png";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from "../../api/axiosInstance";
import axiosInstance from "../../api/axiosInstance";
import { AuthContext } from "../../context/AuthContext";
import Env from "../../runtimeEnv";
import HelpCenter from "../HelpCenter/HelpCenter";
import HelpCenterDetail from "../HelpCenter/HelpCenterDetail";
import learningContent from "../HelpCenter/learningContent.json";
import TherapistHome from "./TherapistHome"
import sessionIcon from "../../assets/images/session.svg";
import clientIcon from "../../assets/images/client.svg";
import helpIcon from "../../assets/images/help.svg";
import shieldIcon from "../../assets/images/shield.svg";
import learningIcon from "../../assets/images/mortarboard.svg";
import learningCenterHero from "../../assets/images/learning-center-hero.png";
import localHelpSections from "../HelpCenter/helpContent";
import { createDemoMeetings, demoTherapistClients, isDemoMode } from "../../demo/demoMode";
import { isNativeMobileShell, launchNativeUnitySession } from "../../native/mobileBridge";
import {
  createInitialUnityPreloadStates,
  isDesktopUnityPreloadEligible,
  isUnityRoomCached,
  markUnityRoomPreloaded,
  preloadUnityRoom,
  prioritizeUnityRooms,
} from "../../utils/unityWebglPreloader";
import { preloadUnityRoomLoadingImages } from "../../utils/unityRoomLoadingImages";
import useTherapistProgress from "../../hooks/useTherapistProgress";

const THERAPIST_PRELOAD_ROOMS = [
  { id: "beach" },
  { id: "mountain" },
  { id: "park" },
  { id: "campsite" },
  { id: "winter-holiday" },
];

function TherapistTherapyRooms() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const [enabledRoom, setEnabledRoom] = useState([]);
  const [loading, setLoading] = useState(true);
  const [roomsOnlineStatus, setRoomsOnlineStatus] = useState({});
  const [sessionStartTimes, setSessionStartTimes] = useState({});
  const [selectedSpace, setSelectedSpace] = useState(null);
  const selectedSpaceRef = useRef(selectedSpace);
  selectedSpaceRef.current = selectedSpace;
  const [preloadStates, setPreloadStates] = useState(() =>
    createInitialUnityPreloadStates(THERAPIST_PRELOAD_ROOMS)
  );
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [activeNavItem, setActiveNavItem] = useState("home");
  const [selectedClient, setSelectedClient] = useState(null);
  const [clientsData, setClientsData] = useState(null);
  const [clientsDataLoading, setClientsDataLoading] = useState(false);
  const [hasFetchedData, setHasFetchedData] = useState(false);
  const { record: therapistProgress, update: updateTherapistProgress } = useTherapistProgress();

  useEffect(() => {
    if (isDesktopUnityPreloadEligible()) {
      void preloadUnityRoomLoadingImages();
    }
  }, []);

  const {
    currentNickname,
    setCurrentNickname,
    PlutonicuserID,
    userType,
    selectedTherapyType,
    isAdmin
  } = useContext(AuthContext);

  const [selectedHelpSection, setSelectedHelpSection] = useState(null);
  const [helpSections, setHelpSections] = useState([]);
  const [loadingHelp, setLoadingHelp] = useState(true);
  const helpArticles = helpSections.filter((section) => section.category === "help");
  const policyArticles = helpSections.filter((section) => section.category === "policies");
  const [selectedPolicySection, setSelectedPolicySection] = useState(null);
  const [learningSections, setLearningSections] = useState(learningContent);
  const [loadingLearning, setLoadingLearning] = useState(false);
  const [selectedLearningSection, setSelectedLearningSection] = useState(null);
  const learningArticles = learningSections.filter(
    (section) =>
      section.category === "learning" &&
      section.showInLearningCenter !== false
  );
  const [homeChecklist, setHomeChecklist] = useState([]);


useEffect(() => {
  const fetchChecklist = async () => {
    if (isDemoMode) {
      setHomeChecklist([
        { id: "profile", name: "Complete your therapist profile" },
        { id: "first-session", name: "Review your upcoming sessions" },
        { id: "help", name: "Explore the Help Center" },
      ]);
      return;
    }
    try {
      const res = await fetch(
        "https://react-resources.s3.us-east-1.amazonaws.com/homeChecklist.json?v=" + Date.now()
      );

      const data = await res.json();
      setHomeChecklist(data);
    } catch (err) {
      console.error("TherapistTherapyRooms: error event");
    }
  };

  fetchChecklist();
}, []);

useEffect(() => {
  const fetchHelp = async () => {
    if (isDemoMode) {
      setHelpSections(localHelpSections);
      setLoadingHelp(false);
      return;
    }
    try {
      const res = await fetch(
        "https://react-resources.s3.us-east-1.amazonaws.com/helpContent.json?v=" + Date.now()
      );

      if (!res.ok) throw new Error("Failed to fetch");

      const data = await res.json();
      setHelpSections(data);
    } catch (err) {
      console.error("Help content failed:");
      setHelpSections([]);
    } finally {
      setLoadingHelp(false);
    }
  };

  fetchHelp();
}, []);

useEffect(() => {
  const stateTab = location.state?.tab;

  if (location.pathname.startsWith("/clients")) {
    setActiveNavItem("clients");
    return;
  }

  if (location.pathname === "/") {
  setActiveNavItem(stateTab ?? "home");
  return;
}
}, [location.pathname, location.state]);

useEffect(() => {
  window.scrollTo({ top: 0, behavior: "auto" });
}, [activeNavItem]);

useEffect(() => {
  const match = location.pathname.match(/^\/(helpcenter|learningcenter|policies)\/([^/]+)$/);
  if (!match) return;
  const [, routeArea, sectionId] = match;
  const area = routeArea === "helpcenter" ? "help" : routeArea === "learningcenter" ? "learning" : "policies";
  const source = area === "learning" ? learningSections : helpSections;
  const section = source.find((item) => item.id === decodeURIComponent(sectionId));
  if (!section) return;
  setActiveNavItem(area);
  if (area === "help") setSelectedHelpSection(section);
  if (area === "learning") setSelectedLearningSection(section);
  if (area === "policies") setSelectedPolicySection(section);
  updateTherapistProgress(area, section, { opened: true });
}, [location.pathname, helpSections, learningSections, updateTherapistProgress]);

const openTrackedSection = (area, section) => {
  updateTherapistProgress(area, section, { opened: true });
  if (area === "help") setSelectedHelpSection(section);
  if (area === "learning") setSelectedLearningSection(section);
  if (area === "policies") setSelectedPolicySection(section);
  navigate(`/${area === "help" ? "helpcenter" : area === "learning" ? "learningcenter" : "policies"}/${section.id}`);
};

useEffect(() => {
  if (activeNavItem !== "learning") return;

  const fetchLearning = async () => {
    setLoadingLearning(true);
    try {
      const response = await fetch(
        "https://react-resources.s3.us-east-1.amazonaws.com/learningContent.json?v=" + Date.now()
      );
      if (!response.ok) throw new Error("Failed to fetch learning content");
      setLearningSections(await response.json());
    } catch (error) {
      console.error("Learning content failed:", error);
      setLearningSections(learningContent);
    } finally {
      setLoadingLearning(false);
    }
  };

  fetchLearning();
}, [activeNavItem]);

  useEffect(() => {
    if (params.sessionID && activeNavItem === "clients") {
      if (clientsData) {
        const targetSession = findSessionInClientsData(
          clientsData,
          params.sessionID
        );
        if (targetSession) {
          setSelectedClient(targetSession);
        } else {
          fetchClientsData(true).then((freshData) => {
            if (freshData) {
              const freshSession = findSessionInClientsData(
                freshData,
                params.sessionID
              );
              if (freshSession) {
                setSelectedClient(freshSession);
              }
            }
          });
        }
      } else {
        fetchClientsData().then((data) => {
          if (data) {
            const foundSession = findSessionInClientsData(
              data,
              params.sessionID
            );
            if (foundSession) {
              setSelectedClient(foundSession);
            }
          }
        });
      }
    } else if (!location.pathname.startsWith("/clients/")) {
      setSelectedClient(null);
    }
  }, [params.sessionID, activeNavItem, location.pathname]);

  useEffect(() => {
    const updateSidebarForScreen = () => {
      if (typeof window !== "undefined") {
        setSidebarCollapsed(window.innerWidth < 1024);
      }
    };
    updateSidebarForScreen();
    window.addEventListener("resize", updateSidebarForScreen);
    return () => window.removeEventListener("resize", updateSidebarForScreen);
  }, []);

  const { refreshMeetings, refreshing, refreshError } = useMeetingsRefresh(async (signal) => {
      const savedUserID =
        PlutonicuserID || localStorage.getItem("PlutonicuserID");
      const savedNickname =
        currentNickname || localStorage.getItem("currentNickname");

      if (savedNickname) {
        setCurrentNickname(savedNickname);
      }

      if (savedUserID) {
        try {
          const meetingRows = isDemoMode
            ? createDemoMeetings()
            : (await axios.get(
                `${Env.REACT_APP_PYTHON_API_URL}/api/GetMeetings/${savedUserID}`,
                { withCredentials: true,
                  signal,
                  headers: {
                    "Cache-Control": "no-cache",
                    Pragma: "no-cache",
                    Expires: "0",
                  },
                  params: { t: new Date().getTime() },
                }
              )).data;

          if (signal.aborted) return;
          if (meetingRows.length > 0) {
            const nowUTC = new Date();

            const gracePeriodBeforeMs = 15 * 60 * 1000;
            const gracePeriodAfterMs = 75 * 60 * 1000;
            const backToBackBufferMs = 20 * 60 * 1000;

            let latestUpcomingSession = null;

            const roomSessionsMap = meetingRows.reduce((acc, room) => {
              const roomId = room.meetingID.split(".")[0].replace("-therapy", "");
              const sessionTimeUTC = new Date(room.sessionTime);

              const formattedTimeEST =
                sessionTimeUTC.toLocaleString("en-US", {
                  timeZone: "America/New_York",
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                }) + " EST";

              if (!acc[roomId]) acc[roomId] = [];

              acc[roomId].push({
                meetingID: room.meetingID,
                sessionStartTimeEST: formattedTimeEST,
                sessionStartTimeUTC: sessionTimeUTC.toISOString(),
                rawStartTime: sessionTimeUTC,
                online: room.online.some((s) => s === true),
                selectedSpace: room.selectedSpace || "",
                isAvailable: false,
                isUpcoming: false,
              });

              return acc;
            }, {});

            Object.keys(roomSessionsMap).forEach((roomId) => {
              const sessions = roomSessionsMap[roomId];

              sessions.sort((a, b) => {
                if (a.isPrimary && !b.isPrimary) return -1;
                if (!a.isPrimary && b.isPrimary) return 1;
                return (
                  new Date(a.sessionStartTimeUTC) -
                  new Date(b.sessionStartTimeUTC)
                );
              });

              for (let i = 0; i < sessions.length; i++) {
                const current = sessions[i];
                const next = sessions[i + 1];

                const currentStart = new Date(current.sessionStartTimeUTC);
                const timeUntilCurrent = currentStart - nowUTC;
                const timeSinceCurrent = nowUTC - currentStart;

                const isInGraceWindow =
                  (timeUntilCurrent <= gracePeriodBeforeMs &&
                    timeUntilCurrent >= 0) ||
                  (timeSinceCurrent >= 0 &&
                    timeSinceCurrent <= gracePeriodAfterMs);

                const isUpcoming =
                  timeUntilCurrent > 0 &&
                  timeUntilCurrent <= gracePeriodBeforeMs;

                let isSuppressed = false;

                if (next) {
                  const nextStart = new Date(next.sessionStartTimeUTC);
                  const timeUntilNext = nextStart - nowUTC;

                  const allowSuppression =
                    timeUntilNext <= backToBackBufferMs &&
                    timeUntilNext >= -15 * 60 * 1000;

                  if (allowSuppression) {
                    isSuppressed = true;
                    next.isUpcoming = true; 
                  }
                }

                current.isAvailable = isInGraceWindow;
                current.isUpcoming = isUpcoming;
                current.isPrimary =
                  (isInGraceWindow || isUpcoming) && !isSuppressed;

                if (
                  current.isPrimary &&
                  current.selectedSpace?.trim() !== "" &&
                  (!latestUpcomingSession ||
                    currentStart >
                      new Date(latestUpcomingSession.sessionStartTimeUTC))
                ) {
                  latestUpcomingSession = current;
                }
              }
            });

            const sessionStartTimesMap = Object.entries(roomSessionsMap).reduce(
              (acc, [roomId, sessions]) => {
                const nextSession = sessions.find(
                  (s) => s.isAvailable || s.isUpcoming
                );
                if (nextSession) acc[roomId] = nextSession.sessionStartTimeEST;
                return acc;
              },
              {}
            );

            const onlineStatusMap = Object.entries(roomSessionsMap).reduce(
              (acc, [roomId, sessions]) => {
                acc[roomId] = sessions.some((s) => s.online);
                return acc;
              },
              {}
            );

            if (latestUpcomingSession) {
              setSelectedSpace(latestUpcomingSession.selectedSpace || null);
            } else {
              setSelectedSpace(null);
            }

            setRoomsOnlineStatus(onlineStatusMap);
            setEnabledRoom(roomSessionsMap);
            setSessionStartTimes(sessionStartTimesMap);
          } else {
            setEnabledRoom({});
            setRoomsOnlineStatus({});
            setSessionStartTimes({});
            setSelectedSpace(null);
          }
        } catch (error) {
          if (!signal.aborted) setLoading(false);
          throw error;
        }
      }

      if (!signal.aborted) setLoading(false);
  }, PlutonicuserID);

  const normalRooms = [
    {
      id: "zen-garden",
      title: "Plutonic Therapy Zen Garden",
      description:
        "Step into a calming Zen inspired retreat designed to help you relax, reflect, and feel more comfortable opening up with your therapist.",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Seasonal",
      usage: "Seasonal",
      image: zen,
      available:
        enabledRoom["zen-garden"]?.some((session) => session.isAvailable) ||
        false,
      selectable: false, // Selectable if a meeting exists
      // enterable: enabledRoom["park"]?.some((session) => session.isAvailable) ?? false, // Enterable only if within grace period
      isComingSoon: true,
      online: false,
      sessionStartTimeEST: "",
    },
    {
      id: "beach",
      title: "Plutonic Therapy Beach Office",
      description:
        "Consider having a session with your licensed mental health professional inside the office or in the cabana. Take in the sounds of the ocean waves and the sunset as you reduce stress.",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Modern Design",
      usage: "Family Counseling",
      image: beach,
      // available: enabledRoom["beach"]?.some((session) => session.isAvailable) || false,
      selectable: enabledRoom["beach"]?.length > 0 ?? false, // Selectable if a meeting exists
      available:
        enabledRoom["beach"]?.some((session) => session.isAvailable) ?? false, // Enterable only if within grace period
      isComingSoon: false,
      online: roomsOnlineStatus["beach"] || false,
      sessionStartTimeEST: sessionStartTimes["beach"] || "",
    },
    {
      id: "mountain",
      title: "Plutonic Therapy Forest Office",
      description:
        "Consider having a session with your licensed mental health professional next to the fireplace. Take in the sounds and sights of the forest.",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Modern Design",
      usage: "Family Counseling",
      image: forest,
      // available: enabledRoom["mountain"]?.some((session) => session.isAvailable) || false,
      // selectable: false, // Cannot select "coming soon" rooms
      available:
        enabledRoom["mountain"]?.some((session) => session.isAvailable) ||
        false,
      selectable: enabledRoom["mountain"]?.length > 0 ?? false, // Selectable if a meeting exists
      isComingSoon: false,
      online: roomsOnlineStatus["mountain"] || false,
      sessionStartTimeEST: sessionStartTimes["mountain"] || "",
    },

    {
      id: "park",
      title: "Plutonic Therapy Quiet Park",
      description:
        "Consider having a session with your licensed mental health professional while taking a walk around the park or while sitting on a park bench. This quiet park is a perfect safe space to talk.",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Green Space",
      usage: "Family Counseling",
      image: park,
      available:
        enabledRoom["park"]?.some((session) => session.isAvailable) || false,
      selectable: enabledRoom["park"]?.length > 0 ?? false, // Selectable if a meeting exists
      // enterable: enabledRoom["park"]?.some((session) => session.isAvailable) ?? false, // Enterable only if within grace period
      isComingSoon: false,
      online: roomsOnlineStatus["park"] || false,
      sessionStartTimeEST: sessionStartTimes["park"] || "",
    },
    {
      id: "campsite",
      title: "Plutonic Therapy Campfire",
      description:
        "Unpack your thoughts with your licensed mental health professional next to the campfire. Trees swaying and crickets chirping while enjoying the beautiful night sky. ",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Green Space",
      usage: "Family Counseling",
      image: campsite,
      available:
        enabledRoom["campsite"]?.some((session) => session.isAvailable) ||
        false,
      selectable: enabledRoom["campsite"]?.length > 0 ?? false, // Selectable if a meeting exists
      // enterable: enabledRoom["park"]?.some((session) => session.isAvailable) ?? false, // Enterable only if within grace period
      isComingSoon: false,
      online: roomsOnlineStatus["campsite"] || false,
      sessionStartTimeEST: sessionStartTimes["campsite"] || "",
    },
    {
                  id: "winter-holiday",
                  title: "Plutonic Therapy Winter Cabin",
                  description:
                    "Step into a cozy winter lodge where soft snow falls outside and warm lantern lights fills the cabin. Settle into the gentle winter ambience.",
                  accessibility: "PC Web Browser | Chrome, Edge",
                  style: "Seasonal",
                  usage: "Seasonal",
                  image: winterHoliday,
                  available:
                    enabledRoom["winter-holiday"]?.some((session) => session.isAvailable) ||
                    false,
                  selectable: enabledRoom["winter-holiday"]?.length > 0 ?? false, // Selectable if a meeting exists
                  // enterable: enabledRoom["park"]?.some((session) => session.isAvailable) ?? false, // Enterable only if within grace period
                  isComingSoon: false,
                  online: roomsOnlineStatus["winter-holiday"] || false,
                  sessionStartTimeEST: sessionStartTimes["winter-holiday"] || "",
                },
  ];

  // TODO: We can remove this if a therapist is not using AI
  const aiRooms = [
    {
      id: "beach-ai-companion",
      title: "Plutonic Beach Office",
      description:
        "Talk to your mental health companion inside the office or in the cabana. Take in the sounds of the ocean waves and the sunset.",
      accessibility: "PC Web Browser | Chrome, Edge, Firefox",
      style: "Modern Design",
      usage: "Family Counseling",
      image: beach,
      selectable: true,
      available: true,
      isComingSoon: false,
      online: true,
      sessionStartTimeEST: "Always Available",
    },
    // {
    //   id: "mountain-ai-companion",
    //   title: "Plutonic Therapy Forest Office",
    //   description:
    //     "Consider having a session with your licensed mental health professional next to the fireplace. Take in the sounds and sights of the forest.",
    //   accessibility: "PC Web Browser | Chrome, Edge",
    //   style: "Modern Design",
    //   usage: "Family Counseling",
    //   image: forest,
    //   available: false,
    //   selectable: false,
    //   isComingSoon: true,
    //   online: false,
    //   sessionStartTimeEST: "Unavailable",
    // },

    // {
    //   id: "park-ai-companion",
    //   title: "Plutonic Therapy Quiet Park",
    //   description:
    //     "Consider having a session with your licensed mental health professional while taking a walk around the park or while sitting on a park bench. This quiet park is a perfect safe space to talk.",
    //   accessibility: "PC Web Browser | Chrome, Edge",
    //   style: "Green Space",
    //   usage: "Family Counseling",
    //   image: park,
    //   available: false,
    //   selectable: false,
    //   isComingSoon: true,
    //   online: false,
    //   sessionStartTimeEST: "Unavailable",
    // },
    {
      id: "campsite-ai-companion",
      title: "Plutonic Campfire",
      description:
        "Unpack your thoughts with your mental health companion next to the campfire. Trees swaying and crickets chirping while enjoying the beautiful night sky.",
      accessibility: "PC Web Browser | Chrome, Edge, Firefox",
      style: "Green Space",
      usage: "Family Counseling",
      image: campsite,
      available: false,
      selectable: false,
      isComingSoon: true,
      online: false,
      sessionStartTimeEST: "Unavailable",
    },
  ];

  const normalRoomOrder = ["beach", "campsite", "mountain", "park", "winter-holiday"];
  const orderedNormalRooms = normalRooms
    .filter((room) => room.id !== "zen-garden")
    .sort((a, b) => normalRoomOrder.indexOf(a.id) - normalRoomOrder.indexOf(b.id));
  const selectedRoomSet = selectedTherapyType === "ai" ? aiRooms : orderedNormalRooms;
  const selectedRooms = isNativeMobileShell()
    ? selectedRoomSet.map((room) =>
        room.id === "beach"
          ? room
          : {
              ...room,
              available: false,
              selectable: false,
              isComingSoon: true,
              online: false,
              unavailableLabel: "Coming Soon on Mobile",
            }
      )
    : selectedRoomSet;

  useEffect(() => {
    if (loading || !isDesktopUnityPreloadEligible() || selectedTherapyType === "ai") {
      return undefined;
    }

    const controller = new AbortController();
    const roomsToPreload = prioritizeUnityRooms(
      THERAPIST_PRELOAD_ROOMS,
      selectedSpaceRef.current
    );

    const preloadInPriorityOrder = async () => {
      await preloadUnityRoomLoadingImages();
      if (controller.signal.aborted) return;
      const cacheResults = await Promise.all(roomsToPreload.map(async (room) => {
        const cached = await isUnityRoomCached(room.id, controller.signal);
        if (!controller.signal.aborted) {
          setPreloadStates((states) => ({
            ...states,
            [room.id]: cached
              ? { status: "complete", progress: 1, blocksEntry: false }
              : { status: "queued", progress: 0, blocksEntry: false },
          }));
        }
        return [room.id, cached];
      }));
      if (controller.signal.aborted) return;
      const cachedRoomIds = new Set(
        cacheResults.filter(([, cached]) => cached).map(([roomId]) => roomId)
      );
      for (const room of roomsToPreload) {
        if (controller.signal.aborted) return;
        if (cachedRoomIds.has(room.id)) continue;
        setPreloadStates((states) => ({
          ...states,
          [room.id]: { status: "loading", progress: 0, blocksEntry: false },
        }));
        try {
          await preloadUnityRoom(
            room.id,
            (progress) => setPreloadStates((states) => ({
              ...states,
              [room.id]: { status: "loading", progress, blocksEntry: false },
            })),
            controller.signal
          );
          markUnityRoomPreloaded(room.id);
          setPreloadStates((states) => ({
            ...states,
            [room.id]: { status: "complete", progress: 1 },
          }));
        } catch (error) {
          if (controller.signal.aborted || error.name === "AbortError") return;
          console.warn(`Unable to preload ${room.id}. The space can still be opened normally.`, error);
          setPreloadStates((states) => ({
            ...states,
            [room.id]: { status: "error", progress: 0 },
          }));
        }
      }
    };

    void preloadInPriorityOrder().catch((error) => {
      if (!controller.signal.aborted && error.name !== "AbortError") {
        console.warn("Unable to initialize Unity space preloading.", error);
      }
    });
    return () => controller.abort();
  }, [loading, selectedTherapyType]);

  const fetchClientsData = async (forceRefresh = false) => {
    if (isDemoMode) {
      setClientsData(demoTherapistClients);
      setHasFetchedData(true);
      return demoTherapistClients;
    }
    if (!forceRefresh && clientsData) {
      return clientsData;
    }

    if (!forceRefresh && (clientsDataLoading || hasFetchedData)) {
      return clientsData;
    }

    try {
      setClientsDataLoading(true);
      if (forceRefresh) {
        setHasFetchedData(false);
      }
      const response = await axiosInstance.get("/api/summarize");

      if (response.data) {
        setClientsData(response.data);
        setHasFetchedData(true);
        return response.data;
      }
    } catch (error) {
      console.error("Error fetching clients data:");
    } finally {
      setClientsDataLoading(false);
    }
    return null;
  };

  const findSessionInClientsData = (data, sessionID) => {
    if (!data || !data.clients) return null;

    for (const client of data.clients) {
      if (client.sessions) {
        const session = client.sessions.find((s) => s.sessionID === sessionID);
        if (session) {
          return {
            ...client,
            sessions: [session],
            selectedSessionID: sessionID,
          };
        }
      }
    }
    return null;
  };

  const handleViewClientHistory = (client) => {
    setSelectedClient(client);
  };

  const handleBackToClients = () => {
    setSelectedClient(null);
    navigate("/clients");
  };

  const handleAvatarSettingChanged = (clientId, avatarsEnabled) => {
    setClientsData((current) => {
      if (!current?.clients) return current;
      return {
        ...current,
        clients: current.clients.map((client) =>
          client.id === clientId ? { ...client, avatarsEnabled } : client
        ),
      };
    });
  };

  const handleEnterClick = (roomType, meetingID = "") => {
    const userId = PlutonicuserID || localStorage.getItem("PlutonicuserID");

    if (meetingID && launchNativeUnitySession({
      roomId: roomType,
      sessionId: meetingID,
      userId,
      displayName: currentNickname || localStorage.getItem("currentNickname"),
      userType,
    })) {
      return;
    }

    if (roomType.startsWith("test-")) {
      const testMeetingID = `${roomType}-test-meeting-id`;
      sessionStorage.setItem("meetingID", testMeetingID);
      sessionStorage.setItem("userId", userId);

      const realRoomType = roomType.replace("test-", ""); 
      navigate(`/unity-room/${realRoomType}`);
      return;
    }

    const roomSessions = enabledRoom[roomType];
    if (!roomSessions || roomSessions.length === 0) {
      alert("Room is not enabled. Please wait or check your eligibility.");
      return;
    }

    if (roomType.includes("-ai-")) {
      const aiMeetingID = `${roomType}-meeting-${userId}`;
      sessionStorage.setItem("meetingID", aiMeetingID);
      sessionStorage.setItem("userId", userId);
      navigate(`/unity-room/${roomType}`);
      return;
    }

    const session = roomSessions.find((s) => s.meetingID === meetingID);
    if (!session) {
      alert("Selected session is not available.");
      return;
    }

    sessionStorage.setItem("meetingID", session.meetingID);
    sessionStorage.setItem("userId", userId);
    navigate(`/unity-room/${roomType}`);
  };

  // if (loading) {
  //   return (
  //     <div
  //       style={{
  //         height: "100vh",
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "center",
  //       }}
  //     >
  //       <p>Loading...</p>
  //     </div>
  //   );
  // }

  return (
  <div>
    <Navbar />

    {userType === "Therapist" && (
      <TherapistSidebar
        activeNavItem={activeNavItem}
        setActiveNavItem={setActiveNavItem}
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
        learningSubsections={learningSections.filter((section) =>
          [
            "learning-children-preteens-examples",
            "learning-adolescents-examples",
          ].includes(section.id)
        )}
        selectedLearningSectionId={selectedLearningSection?.id}
        onSelectLearningSection={(section) => {
          setSelectedLearningSection(section);
          setActiveNavItem("learning");
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
      />
    )}

       {activeNavItem === "home" ? (
  <div
  className={`min-h-screen pt-24 pb-16 transition-all duration-300 ${
    sidebarCollapsed ? "lg:ml-16" : "lg:ml-64"
  }`}
>
    <TherapistHome
  therapistName={currentNickname}
  therapistId={PlutonicuserID || localStorage.getItem("PlutonicuserID")}
  checklistData={homeChecklist}
  onInternalLink={(link) => {
    if (link.type === "help") {
      const section = helpSections.find((s) => s.id === link.id);

      if (section) {
        setSelectedHelpSection(section);
        setActiveNavItem("help");
        window.scrollTo({
  top: 0,
  behavior: "smooth"
});
      }
    }

    if (link.type === "policies") {
      const section = helpSections.find((s) => s.id === link.id);

      if (section) {
        setSelectedPolicySection(section);
        setActiveNavItem("policies");
        window.scrollTo({
  top: 0,
  behavior: "smooth"
});
      }
    }

    if (link.type === "learning") {
      const section = learningSections.find((item) => item.id === link.id);
      if (section) {
        setSelectedLearningSection(section);
        setActiveNavItem("learning");
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  }}
  quickActions={[
  {
    id: "sessions",
    name: "Sessions",
    icon: sessionIcon,
    onClick: () => navigate("/", { state: { tab: "sessions" } }),
  },
  {
    id: "clients",
    name: "Clients",
    icon: clientIcon,
    onClick: () => navigate("/clients"),
  },
  {
    id: "help",
    name: "Help Center",
    icon: helpIcon,
    onClick: () => navigate("/", { state: { tab: "help" } }),
  },
  {
    id: "learning",
    name: "Learning Center",
    icon: learningIcon,
    onClick: () => navigate("/", { state: { tab: "learning" } }),
  },
  {
    id: "policies",
    name: "Policies",
    icon: shieldIcon,
    onClick: () => navigate("/", { state: { tab: "policies" } }),
  },
]}
/>
  </div>
) :

    activeNavItem === "sessions" ? (
      <div
        className={`fall-page-background therapy-rooms-page relative min-h-screen pt-24 pb-16 transition-all duration-300 ${
          sidebarCollapsed ? "lg:ml-16" : "lg:ml-64"
        }`}
      >
        <FallScene />
        <div className="therapy-rooms-page__content relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
          <h2 className="fall-scene-heading therapy-rooms-page__heading text-3xl font-bold mb-12 pl-4 mt-8">
            Your Virtual Spaces
            <RefreshMeetingsButton onRefresh={refreshMeetings} refreshing={refreshing} />
          </h2>
          {refreshError && <p role="alert" className="text-red-600">{refreshError}</p>}

          <div className="therapy-rooms-page__grid grid gap-8 grid-cols-1 md:grid-cols-2 w-full">
            {selectedRooms.map((room) => (
              <TherapyRoomCard
                key={room.id}
                room={room}
                isSelected={selectedSpace === room.id}
                onEnterClick={(meetingID) =>
                  handleEnterClick(room.id, meetingID)
                }
                sessions={enabledRoom[room.id] || []}
                preloadState={preloadStates[room.id]}
              />
            ))}
          </div>
        </div>
      </div>

    ) : activeNavItem === "help" ? (
      <div
        className={`min-h-screen transition-all duration-300 bg-white ${
          sidebarCollapsed ? "lg:ml-16" : "lg:ml-64"
        }`}
      >
        {loadingHelp ? (
  <div className="min-h-screen flex items-center justify-center">
  Loading...
</div>
) : selectedHelpSection ? (
  <HelpCenterDetail
    section={selectedHelpSection}
    onBack={() => { setSelectedHelpSection(null); navigate("/", { state: { tab: "help" } }); }}
  />
) : (
  <HelpCenter
    title="Help Center"
    sections={helpArticles}
    area="help"
    progress={therapistProgress.progress}
    onToggleComplete={(section, completed) => updateTherapistProgress("help", section, { completed })}
    onSelectSection={(section) => openTrackedSection("help", section)}
  />
)}
      </div>

    ) : activeNavItem === "learning" ? (
      <div
        className={`min-h-screen pb-24 pt-[83px] transition-all duration-300 bg-white ${
          sidebarCollapsed ? "lg:ml-16" : "lg:ml-64"
        }`}
      >
        {loadingLearning ? (
          <div className="min-h-screen flex items-center justify-center">
            Loading...
          </div>
        ) : selectedLearningSection ? (
          <HelpCenterDetail
            section={
              learningSections.find(
                (section) => section.id === selectedLearningSection.id
              ) || selectedLearningSection
            }
            onBack={() => { setSelectedLearningSection(null); navigate("/", { state: { tab: "learning" } }); }}
            area="learning"
            progress={therapistProgress.progress}
            onToggleRow={(index, block, completed) => updateTherapistProgress("learning", {
              id: `${selectedLearningSection.id}-row-${index}`,
              title: `${selectedLearningSection.title}: ${block.need || `row ${index + 1}`}`,
            }, { completed })}
            onVideoWatched={(video) => updateTherapistProgress("learning", {
              id: video.itemId,
              title: video.title,
            }, { videoWatched: true })}
          />
        ) : (
          <HelpCenter
            title="Plutonic Learning Center"
            description="Learn practical, evidence-informed strategies for using Plutonic Virtual Therapy across different age groups and clinical presentations. Content focuses on applying platform features to strengthen engagement, therapeutic alliance, and evidence-based interventions."
            heroImage={learningCenterHero}
            heroImageAlt="Virtual therapy and clinician learning illustration"
            disclaimer="Plutonic Virtual Therapy is a therapeutic platform that provides optional virtual environments and interactive features to support psychotherapy. The content within this Learning Center is intended for educational purposes only and does not constitute medical advice, clinical supervision, or a standard of care. References to specific diagnoses or clinical presentations are illustrative of potential applications and are not intended to represent indications for treatment, guarantees of effectiveness, or recommendations that the platform be used with any particular client population. Treating clinicians remain solely responsible for all clinical decisions, treatment planning, risk assessment, and the delivery of care."
            variant="training"
            sections={learningArticles}
            area="learning"
            progress={therapistProgress.progress}
            onToggleComplete={(section, completed) => updateTherapistProgress("learning", section, { completed })}
            onSelectSection={(section) => openTrackedSection("learning", section)}
          />
        )}
      </div>

    ) : activeNavItem === "policies" ? (
      <div
        className={`min-h-screen transition-all duration-300 bg-white ${
          sidebarCollapsed ? "lg:ml-16" : "lg:ml-64"
        }`}
      >
        {loadingHelp ? (
  <div className="min-h-screen flex items-center justify-center">
  Loading...
</div>
) : selectedPolicySection ? (
  <HelpCenterDetail
    section={selectedPolicySection}
    onBack={() => { setSelectedPolicySection(null); navigate("/", { state: { tab: "policies" } }); }}
  />
) : (
  <HelpCenter
    title="Policies"
    sections={policyArticles}
    area="policies"
    progress={therapistProgress.progress}
    onToggleComplete={(section, completed) => updateTherapistProgress("policies", section, { completed })}
    onSelectSection={(section) => openTrackedSection("policies", section)}
  />
)}
      </div>

    ) : activeNavItem === "clients" ? (
      selectedClient ? (
        <div
          className={`transition-all duration-300 ${
            sidebarCollapsed ? "lg:ml-16" : "lg:ml-64"
          }`}
        >
          <ClientChatHistory
            client={selectedClient}
            onBack={handleBackToClients}
          />
        </div>
      ) : (
        <div
          className={`min-h-screen pt-24 pb-16 transition-all duration-300 bg-white ${
            sidebarCollapsed ? "lg:ml-16" : "lg:ml-64"
          }`}
        >
          <div className="w-full mx-auto px-4 sm:px-8 lg:px-12">
            <TherapistClients
              onViewHistory={handleViewClientHistory}
              clientsData={clientsData}
              fetchClientsData={fetchClientsData}
              onAvatarSettingChanged={handleAvatarSettingChanged}
              loading={clientsDataLoading}
              isAdmin={isAdmin}
            />
          </div>
        </div>
      )
    ) : null}

    <Footer />
  </div>
);
}

export default TherapistTherapyRooms;
